module.exports = __webpack_public_path__ + "static/media/201ME250.ed548513.jpg";